class CookiesController {
  constructor (I18n, CookiesService) {
    'ngInject'
    this.I18n = I18n
    this.cookiesService = CookiesService
  }

  openCookiesBanner () {
    this.cookiesService.requestEdit = true
  }
}

export default CookiesController



// WEBPACK FOOTER //
// ./src/app/pages/cookies/cookies.controller.js